import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { MILESTONE_DEFINITIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const reducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case MILESTONE_DEFINITIONS_ACTION_TYPE.GET_MILESTONE_DEFINITIONS:
      case MILESTONE_DEFINITIONS_ACTION_TYPE.CREATE_MILESTONE_DEFINITION:
      case MILESTONE_DEFINITIONS_ACTION_TYPE.UPDATE_MILESTONE_DEFINITION:
      case MILESTONE_DEFINITIONS_ACTION_TYPE.DELETE_MILESTONE_DEFINITION:
        return { ...state, ...payload };

      case MILESTONE_DEFINITIONS_ACTION_TYPE.REORDER_MILESTONE_DEFINITION:
        return { ...state, ...payload };

      case MILESTONE_DEFINITIONS_ACTION_TYPE.REORDER_MILESTONE_DEFINITION_PENDING:
      case MILESTONE_DEFINITIONS_ACTION_TYPE.REORDER_MILESTONE_DEFINITION_REJECTED:
        {
          if (!state.milestoneDefinitionsCollection) {
            break;
          }

          draft.milestoneDefinitionsCollection = {
            ...state.milestoneDefinitionsCollection,
            sequenceMilestones: payload,
          };
        }

        break;

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default reducer;
